export const DRIVER_BUTTON_SIZE = 96

export const SENTIMENT_BUTTON_SIZE = 96
export const SENTIMENT_BUTTON_SIZE_MOBILE = 55

export const SENTIMENT_ICON_SIZE = 50
export const SENTIMENT_ICON_SIZE_MOBILE = 30
